import React from 'react'

import SettingsSection from '../../SettingsSection'
import Checkbox from '../../Controls/Checkbox'

const ENABLED_CHANNELS_KEY = 'n_enabled_channels'

const IncomingMessagesSettings = ({
  values,
  setValues,
  envLoaded,
  user,
  options
}) => {
  const [loaded, setLoaded] = React.useState(false)

  React.useEffect(() => {
    if (!envLoaded || !user) {
      return
    }

    const settings = user.settings ?? []
    const transformed = settings.reduce((prev, curr) => {
      if (curr.key === ENABLED_CHANNELS_KEY) {
        prev[curr.key] = curr.value
        return prev
      }
      prev[curr.key] = curr.value === 'true'
      return prev
    }, {})
    setValues(old => Object.assign({ ...old }, transformed))
    setLoaded(true)
  }, [envLoaded, user, setValues])

  const handleCheck = React.useCallback(
    opt => val => {
      setValues(old => ({ ...old, [opt]: val }))
      if (opt === 'n_peer_push') {
        setValues(old => ({ ...old, n_client_push: val }))
      }
    },
    [setValues]
  )

  return (
    <SettingsSection title='Incoming Messages' loaded={loaded && envLoaded}>
      {Object.entries(options).map(([key, text]) => (
        <Checkbox
          key={key}
          checked={Boolean(values[key])}
          onCheck={handleCheck(key)}
        >
          {text}
        </Checkbox>
      ))}
    </SettingsSection>
  )
}

export default IncomingMessagesSettings
